import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useSnackbar } from "notistack"
import Constants from "src/components/Common/Constants"
import * as FirestoreService from "./services/guardiaFirestore"

const useGuardiaNotificationFeed = () => {
  const conjunto = useSelector(state => state.complex.complex)
  const { enqueueSnackbar } = useSnackbar()
  const [visitasAnticipadas, setVisitasAnticipadas] = useState([])

  useEffect(() => {
    if (!conjunto.id) return
    FirestoreService.getTodayEarlyVisitsWithAditionals(
      conjunto.id,
      conjunto.Relacionados
    )
      .then(query => {
        const Items = query.map(doc => {
          const data = doc.data()
          return {
            id: doc.id,
            ...data,
            PlacaVehiculo: data.PlacaVehiculo || "sin vehículo",
            ColorVehiculo: data.ColorVehiculo || "sin vehículo",
            HoraEstimadaLlegada:
              data.HoraEstimadaLlegada.toDate().toLocaleTimeString(),
            TiempoEstimadoSalida:
              Constants.tiemposEstimadosVisita?.find(
                time => time.value === data.TiempoEstimadoSalida
              )?.label || data.TiempoEstimadoSalida,
            TipoVisita:
              Constants.tiposVisita?.find(
                time => time.value === data.TipoVisita
              )?.label || data.TipoVisita,
          }
        })
        setVisitasAnticipadas(Items)
      })
      .catch(() => {
        enqueueSnackbar("Error al obtener las visitas anticipadas de hoy", {
          variant: "error",
        })
      })
  }, [conjunto])

  return {
    title: "Visitas Anticipadas",
    total: visitasAnticipadas.length < 10 ? visitasAnticipadas.length : "+9",
    visitasAnticipadas,
  }
}

export default useGuardiaNotificationFeed
